import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice';
import appointmentReducer from './features/appointments/appointmentsSlice';
import appointmentSearchReducer from './features/appointments/appointmentSearchSlice';
import availabilityReducer from './features/availability/availabilitySlice';
import patientReducer from './features/patients/patientSlice';
import bookingReducer from './features/booking/bookingSlice';
import consultationReducer from "./features/consultations/consultationSlice";
import consultationHistoryReducer from "./features/consultations/consultationHistorySlice";
import billingReducer from './features/billing/billingSlice';
import profileReducer from './features/doctors/profileSlice';
import clinicProfile from './features/clinics/clinicProfileSlice';
import patientBillingReducer from './features/billing/patientBillingSlice';
import prescriptionsReducer from './features/prescriptions/prescriptionsSlice';
import doctorsReducer from './features/doctors/doctorsSlice';
import onboardingReducer from './features/doctors/onboardingSlice';
import doctorDashboardReducer from './features/doctors/dashboardSlice';
import patientDashboardReducer from './features/patients/dashboardSlice';
import subscriptionReducer from './features/billing/subscriptionSlice';
import homepageReducer from './features/homepage/homepageSlice';
import publicDoctorReducer from './features/doctors/publicDoctorSlice';
import messagingReducer from './features/messaging/messagingSlice';
import feedbackReducer from './features/feedback/feedbackSlice';
import receptionistReducer from './features/receptionist/receptionistSlice';
import { persistStore, persistReducer } from 'redux-persist';
import errorReducer from './features/errorSlice';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'],
};

const rootReducer = combineReducers({
    auth: authReducer,
    appointments: appointmentReducer,
    appointmentSearch: appointmentSearchReducer,
    availability: availabilityReducer,
    booking: bookingReducer,
    patients: patientReducer,
    consultations: consultationReducer,
    consultationHistory: consultationHistoryReducer,
    billing: billingReducer,
    profile: profileReducer,
    clinic: clinicProfile,
    patientBilling: patientBillingReducer,
    error: errorReducer,
    prescriptions: prescriptionsReducer,
    doctors: doctorsReducer,
    onboarding: onboardingReducer,
    doctorDashboard: doctorDashboardReducer,
    patientDashboard: patientDashboardReducer,
    subscription: subscriptionReducer,
    homepage: homepageReducer,
    publicDoctor: publicDoctorReducer,
    messaging: messagingReducer,
    feedback: feedbackReducer,
    receptionist: receptionistReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        })
});

export const persistor = persistStore(store);
export default store;